export const GET_DATA_CHAT = "GET_DATA_CHAT";
export const GET_AGENT_STATE = "GET_AGENT_STATE";
export const GET_SOLVED_CHAT = "GET_SOLVED_CHAT";
export const GET_CHAT_AGENT = "GET_CHAT_AGENT";
export const GET_SUMMARY_AGENT = "GET_SUMMARY_AGENT";
export const SET_DASHBOARD_ERROR = "SET_DASHBOARD_ERROR";
export const GET_SUMMARY_RESULT = "GET_SUMMARY_RESULT";
export const GET_SUMMARY_SOLVED = "GET_SUMMARY_SOLVED";
